import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { EMPTY_STRING } from '../../constants/SharedConstants';
import { HEADER_BACKGROUND_IMAGE_STYLE } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import BackgroundImageField from './BackgroundImageField';
import ColorPickerField from './ColorPickerField';
import PatternField from './PatternField';
import { getPatternUrl } from '../utils/templateHeaderPatternUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_I18N_KEY = 'knowledgeContentUI.templateEditor.fields.headerBackground';
class HeaderBackgroundField extends Component {
  constructor(...args) {
    super(...args);
    this.onColorChange = ({
      color
    }) => {
      this.props.onFieldChange(Object.assign({}, this.props.value, {
        color,
        backgroundPatternSrc: getPatternUrl(this.props.value.backgroundPatternSrc, color)
      }));
    };
    this.onBackgroundImageChange = ({
      imageSrc,
      imageStyle
    }) => {
      this.props.onFieldChange(Object.assign({}, this.props.value, {
        backgroundGradientType: undefined,
        backgroundImageSrc: imageSrc || EMPTY_STRING,
        backgroundImageStyle: imageStyle || HEADER_BACKGROUND_IMAGE_STYLE.STRETCH,
        backgroundPatternSrc: undefined
      }));
    };
    this.onPatternChange = ({
      gradientType,
      imageSrc
    }) => {
      this.props.onFieldChange(Object.assign({}, this.props.value, {
        backgroundGradientType: gradientType,
        backgroundImageSrc: undefined,
        backgroundImageStyle: undefined,
        backgroundPatternSrc: imageSrc
      }));
    };
  }
  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'readOnly' does not exist on type 'Readon... Remove this comment to see the full error message
    const {
      readOnly,
      value = {}
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(BackgroundImageField, {
        imageSrc: value.backgroundImageSrc,
        imageStyle: value.backgroundImageStyle,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_I18N_KEY}.imageLabel`
        }),
        onFieldChange: this.onBackgroundImageChange,
        readOnly: readOnly
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_I18N_KEY}.colorLabel`
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_I18N_KEY}.colorDescription`
        }),
        children: /*#__PURE__*/_jsx(ColorPickerField, {
          onFieldChange: this.onColorChange,
          value: {
            color: value.color
          },
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_I18N_KEY}.patternsLabel`
        }),
        children: /*#__PURE__*/_jsx(PatternField, {
          color: value.color,
          gradientType: value.backgroundGradientType,
          imageSrc: value.backgroundPatternSrc,
          onFieldChange: this.onPatternChange,
          readOnly: readOnly
        })
      })]
    });
  }
}
export default HeaderBackgroundField;